import React, { useState } from "react";
import Summary from "../../../../components/cases/assets/balanceOfAssets/bankBalance/Summary";

const BankBalances = ({ next, back, tabText }) => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <Summary next={next} back={back} />{" "}
      {/* <SuggestionBox
        mainText={tabText}
        tabName="BankBalances"
        next={showDetails}
        click={() => {
          setShowDetails(!showDetails);
        }}
        setVisited={visited}
      /> */}
    </>
  );
};

export default BankBalances;
